import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        list: (cntx, params) => new Promise((resolve, reject) => {
            axios
                .get('inputs', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        show: (cntx, { id }) => new Promise((resolve, reject) => {
            axios.get(`inputs/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        create: (cntx, params) => new Promise((resolve, reject) => {
            axios
                .post('inputs', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        update: (cntx, params) => new Promise((resolve, reject) => {
            axios
                .put(`inputs/${params.id}`, params.data)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        remove: (cntx, id) => new Promise((resolve, reject) => {
            axios
                .delete(`inputs/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        seasons: (cntx, params) => new Promise((resolve, reject) => {
            axios
                .get('seasons', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),

        prices: (cntx, params) => new Promise((resolve, reject) => {
            axios
                .get('input_prices', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        levels: (cntx, params) => new Promise((resolve, reject) => {
            axios
                .get('levels', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        units: (cntx, params) => new Promise((resolve, reject) => {
            axios
                .get('units', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        currencies: (cntx, params) => new Promise((resolve, reject) => {
            axios
                .get('currencies', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        savePrice: (cntx, params) => new Promise((resolve, reject) => {
            axios
                .post('pricing', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
    },
}
